import React, { Component } from 'react';
import { func, number, string } from 'prop-types';
import { debounce } from 'lodash-es';

class ResponseCategoryDescription extends Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.dispatchChange = debounce((index, lang, value) =>
      props.onChange(index, lang, value), 300);

    this.state = {
      value: props.value
    };
  }

  onChange(event) {
    this.setState({ value: event.target.value });
    this.dispatchChange(this.props.categoryIndex, this.props.lang, event.target.value);
  }

  render() {
    return (
      <input
        type="text"
        value={this.state.value}
        placeholder={this.props.placeholder}
        onChange={this.onChange}
        maxLength={255}
      />
    );
  }
}

ResponseCategoryDescription.propTypes = {
  lang: string.isRequired,
  value: string.isRequired,
  placeholder: string.isRequired,
  onChange: func.isRequired,
  categoryIndex: number.isRequired
};

export default ResponseCategoryDescription;
